import { ApiConfig } from '../types/api';

import { CamionNetBaseApiClient } from './base-client';
import { AuthApi } from './endpoints/auth';
import { ClientsApi } from './endpoints/clients';
import { InterventionsApi } from './endpoints/interventions';
import { PlatesApi } from './endpoints/plates';
import { PlanningApi } from './endpoints/planning';
import { RatesApi } from './endpoints/rates';

/**
 * CamionNet API Client
 * Combines all domain-specific API clients
 */
export class CamionNetApiClient extends CamionNetBaseApiClient {
  public auth: AuthApi;
  public clients: ClientsApi;
  public interventions: InterventionsApi;
  public planning: PlanningApi;
  public plates: PlatesApi;
  public rates: RatesApi;

  constructor(config: ApiConfig) {
    super(config);

    // Initialize domain-specific API clients
    this.auth = new AuthApi(config);
    this.clients = new ClientsApi(config);
    this.interventions = new InterventionsApi(config);
    this.planning = new PlanningApi(config);
    this.plates = new PlatesApi(config);
    this.rates = new RatesApi(config);
  }
}

/**
 * Create an API client instance with the default configuration
 */
export const createApiClient = (): CamionNetApiClient => {
  return new CamionNetApiClient({
    baseUrl: process.env.REACT_APP_BACKEND_HOST || '',
    version: process.env.REACT_APP_VERSION || '',
  });
};

/**
 * Default API client instance
 */
export const apiClient = createApiClient();

// For backward compatibility, re-export the domain-specific types
export * from './endpoints/auth';
export * from './endpoints/clients';
export * from './endpoints/interventions';
export * from './endpoints/planning';
export * from './endpoints/plates';
export * from './endpoints/rates';
